module.exports = __webpack_public_path__ + "static/media/working.e8c6da17.jpg";